import { PhotoIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onClick: () => void;
};

export const AddPicturesButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className="inline-flex items-center gap-x-1 sm:gap-x-2 rounded bg-delicate-800 px-2 sm:px-3.5 py-1.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-sm hover:bg-delicate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-delicate-600"
    >
      <PhotoIcon className="w-4 h-4 sm:w-5 sm:h-5" />
      <span className="sm:hidden">+</span>
      <span className="sm:inline">{t("addPicturesButton.title")}</span>
    </button>
  );
};
